export const staticFunctions = {
    addDevicesClasses() {
        $("body").addClass(((typeof document.body.ontouchstart == "undefined") ? "no-touch" : "touch"));
        if ((/iP/i.test(navigator.userAgent))) {
            $("body").addClass("ios");
        }
    }
};

export function headerFunction() {
    let body = $("body");
    let header = $(".header");
    // let footer = $(".footer");
    let dropSearch = $(".header-search");
    let line = $(".header-line b");
    let isOpenDropSearch = false;
    let doc = $(document);
    let timer;
    let timer2;
    let navListClass = "nav-list";
    let prefix = "show-";
    let navListOpenClass = (prefix + navListClass);
    let headerFixed = function () {
        if (body.hasClass("home")) {
            body.addClass("show-header-fixed");
        }
    };

    header.on("click", ".open-nav", function (e) {
        e.preventDefault();

        if (body.hasClass("show-nav")) {
            body.removeClass(`show-nav show-drop-menu ${navListOpenClass}`);
            $("." + navListClass).find("li.open").removeClass("open");

        } else {
            body.addClass("show-nav");
        }
    });

    $(".header, .footer").on("click", ".search-btn", function (e) {
        /*show search*/
        e.preventDefault();
        isOpenDropSearch = false;
        doc.off("click.eOpenDropSearch");

        if (body.hasClass("show-search")) {
            body.removeClass("show-search");

        } else {
            body.addClass("show-search");
            doc.on("click.eOpenDropSearch", function (e) {

                if (isOpenDropSearch && ($(e.target).closest(dropSearch).length === 0)) {
                    doc.off("click.eOpenDropSearch");
                    isOpenDropSearch = false;
                    body.removeClass("show-search");
                }

                isOpenDropSearch = true;
            });
        }
        /*show search end*/
    });

    $("." + navListClass).on("click", ".arrow", function (e) {
        e.stopPropagation();

        let item = $(this).closest("li");
        let list = item.closest("ul");
        let isOpen = item.hasClass("open");
        let isParentNavList = list.hasClass(navListClass);

        if (isOpen) {
            item.removeClass("open");
            item.find(".sub-menu li.open").removeClass('open');

            if (isParentNavList) {
                body.removeClass(navListOpenClass);
            }
        } else {
            item.addClass("open").siblings().removeClass("open");
            if (isParentNavList) {
                body.addClass(navListOpenClass);
            }
        }
    }).on("click", "> li", function (e) {
        let curTarget = $(e.target);

        if (curTarget.parent().hasClass(navListClass) && curTarget.hasClass("open")) {
            curTarget.find(".nav-item > .arrow").trigger("click");
        }
    });

    $("body.no-touch ." + navListClass).hover(
        function () {
            let currentItemWrap = $(this).find("> .current-menu-item,  > .current-menu-parent, > .current-menu-ancestor");
            currentItemWrap = currentItemWrap.length ? currentItemWrap : $(this).find("> li:eq(0)");

            let currentItem = currentItemWrap.find(".nav-item");
            line.css({
                left: (currentItem.offset().left + "px"),
                width: (currentItem.width() + "px"),
                display: "block",
            });

        }, function () {
            line.css({
                display: "none",
                width: 0
            });
        }
    ).find("> li").hover(
        function () {
            clearInterval(timer2);
            let item = $(this);
            let navItem = $(this).find(".nav-item");

            timer = setInterval(function () {
                item.siblings().removeClass("open");

                if (item.hasClass("menu-item-has-children")) {
                    item.addClass("open");
                    body.addClass("nav-item-has-drop");
                } else {
                    body.removeClass("nav-item-has-drop");
                }

                line.css({
                    width: (navItem.width() + "px"),
                    left: (navItem.offset().left + "px")
                });

            }, 400);
        },
        function () {
            clearInterval(timer);
            let item = $(this);

            timer2 = setInterval(function () {
                item.removeClass("open");

            }, 400);
        }
    );

    header.hover(function () {
            body.addClass("show-nav-list");
        },
        function () {
            body.removeClass("show-nav-list");
        });

    // $(".header-libraries-list a").hover(function () {
    //     let _this = $(this);
    //     $('.nav-list').find('li.menu-item').eq(_this.closest("li.menu-item").index()).find(".header-libraries-descr li").eq(_this.closest("li").index()).addClass("active").siblings().removeClass("active")
    // });

    headerFixed();

    window.addEventListener("scroll", function () {
        headerFixed();

        body.removeClass("show-nav-list");
        $("." + navListClass).find("> li").removeClass('open');
    });

    function banner() {
        let $main = $('.main');
        let $banner = $('.header-banner');
        let $bannerHeight = $banner.innerHeight();
        let $holder_timer = $('.holder-timer');

        if ($banner.length > 0) {
            let top = header.innerHeight() + $bannerHeight;

            header.css('top', $bannerHeight);

            $('.header-line').css('top', top + 'px');

            if (window.innerWidth < 1200) {
                $('.header-content').css('max-height', 'calc(100vh - ' + top + 'px)');
            }

            $('.header-search').css('top', $bannerHeight + 'px');
            $main.css('padding-top', top + 'px');

            if ($holder_timer.length > 0) {
                $holder_timer.css('top', top + 'px');
            }
        }
    }

    $(".slider-banner").on('init', function (event, slick) {
        banner();
    }).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        fade: true
    });

    window.addEventListener("resize load", () => {
        setTimeout(function () {
            banner();
        }, 100);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/module.js